import React, { useEffect, useState } from "react";
import "./ScrollProgressBar.css";

export default function ScrollProgressBar() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollTotal = scrollHeight - clientHeight;
      
      if (scrollTotal > 0) {
        const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
        const progress = (currentPosition / scrollTotal) * 100;
        
        // استخدام طلب الإطار لضمان سلاسة الحركة
        requestAnimationFrame(() => {
          setScrollPosition(progress);
        });
      }
    };

    window.addEventListener("scroll", updateScrollProgress, { passive: true });
    window.addEventListener("resize", updateScrollProgress); // مهم جداً للموبايل عند تغيير الاتجاه
    
    return () => {
      window.removeEventListener("scroll", updateScrollProgress);
      window.removeEventListener("resize", updateScrollProgress);
    };
  }, []);

  return (
    <div className="modern-progress-container">
      <div
        className="modern-progress-bar"
        style={{ width: `${scrollPosition}%` }}
      >
        {/* إضافة لمعة (Reflect) تتحرك مع البار */}
        <div className="progress-glow"></div>
      </div>
    </div>
  );
}